import { render, staticRenderFns } from "./VehicleManifest.vue?vue&type=template&id=bf49ba2c"
import script from "./VehicleManifest.vue?vue&type=script&lang=js"
export * from "./VehicleManifest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports